module.exports = __webpack_public_path__ + "img/flow2.cfd761c1.png";